var _rect, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#587E85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7104 7.22803H19.2894C22.3167 7.22803 24.7718 9.68306 24.7718 12.7104V19.2894C24.7718 22.3167 22.3167 24.7718 19.2894 24.7718H12.7104C9.68306 24.7718 7.22803 22.3167 7.22803 19.2894V12.7104C7.22803 9.68306 9.68306 7.22803 12.7104 7.22803ZM19.295 23.1269C21.4112 23.1269 23.1327 21.4054 23.1327 19.2892V12.7103C23.1327 10.594 21.4112 8.87256 19.295 8.87256H12.7161C10.5998 8.87256 8.87837 10.594 8.87837 12.7103V19.2892C8.87837 21.4054 10.5998 23.1269 12.7161 23.1269H19.295Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6138 15.9984C11.6138 13.5762 13.5776 11.6124 15.9997 11.6124C18.4218 11.6124 20.3856 13.5762 20.3856 15.9984C20.3856 18.4205 18.4218 20.3843 15.9997 20.3843C13.5776 20.3843 11.6138 18.4205 11.6138 15.9984ZM13.2584 15.9983C13.2584 17.5092 14.4887 18.7395 15.9996 18.7395C17.5106 18.7395 18.7408 17.5092 18.7408 15.9983C18.7408 14.4862 17.5106 13.2571 15.9996 13.2571C14.4887 13.2571 13.2584 14.4862 13.2584 15.9983Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7187,
    cy: 11.2847,
    r: 0.584426,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewInstagram);
export default __webpack_public_path__ + "static/media/new_instagram.a33070e691945f74d797dce752e8e6e2.svg";
export { ForwardRef as ReactComponent };